import {ShowHide} from './ShowHideClass';

export class Accordion {
    accordion: HTMLElement;

    constructor(accordion: HTMLElement) {
        this.accordion = accordion;
        this.init();
    }

    init() {
        new ShowHide(
            this.accordion.querySelector('[data-accordion-header]'),
            this.accordion.querySelector('[data-accordion-content]'),
            false,
            true
        );
    }
}
